import { Component, Input, Output, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-resizable-grid-column',
    template: `
    <div class="resizable-grid-column" [style.left.%]="left" [style.width.%]="width">
      <ng-content></ng-content>
      @if (!isLast) {
        <div class="resizer right" (mousedown)="onResizeStart($event)"></div>
      }
    </div>
    `,
    styles: [`
    .resizable-grid-column {
      position: absolute;
      top: 0;
      bottom: 0;
    }
    .resizer {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 5px;
      right: 0;
      background-color: #ccc;
      cursor: col-resize;
    }
  `],
    standalone: false
})
export class ResizableGridColumnComponent implements AfterViewInit {
  @Input() left: number = 0;
  @Input() width: number = 50;
  @Input() minWidth: number = 10;
  @Input() isLast: boolean = false;
  @Output() resized = new EventEmitter<{index: number, newWidth: number}>();
  index: number = 0;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.updatePosition();
  }

  updatePosition() {
    const element = this.el.nativeElement;
    element.style.left = `${this.left}%`;
    element.style.width = `${this.width}%`;
  }

  onResizeStart(event: MouseEvent) {
    event.preventDefault();
    const startX = event.clientX;
    const startWidth = this.width;
    const parentWidth = this.el.nativeElement.parentElement.offsetWidth;

    const onMouseMove = (e: MouseEvent) => {
      const deltaX = e.clientX - startX;
      const deltaPercent = (deltaX / parentWidth) * 100;
      const newWidth = Math.max(this.minWidth, Math.min(100 - this.left, startWidth + deltaPercent));
      this.resized.emit({index: this.index, newWidth});
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }
}
